module.exports = __webpack_public_path__ + "media/images/seamless-pattern-aab37ed0936ac438453e92e599a2669b.svg";